import { css } from '@adornis/chemistry/directives/css.js';
import type { XTinyMCEPlugin } from '@adornis/writer/x-tinymce.js';
import type { CampusLesson } from '@chancenwerk/campus-learning-content/entities/CampusLesson.js';
import { CampusArea } from '@chancenwerk/campus-learning-content/entities/CampusSection.js';
import { projectConfig } from '@chancenwerk/config.js';
import { GroupType } from '@chancenwerk/db/enums/enums.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('campus-tiny-plugin-jumpmarks')
export class CampusTinyPluginJumpmarks extends ChromiumDialog<{ link: string; lessonName: string } | undefined> {
  private _link: string | undefined = undefined;

  static override get element_name() {
    return 'campus-tiny-plugin-jumpmarks';
  }

  override heading = 'Lektion auswählen';

  override content() {
    return html`
      <campus-component-section-lesson-list
        flex
        ${css({ overflowY: 'auto', minHeight: '0' })}
        .area=${CampusArea.STUDENTS}
        .mode=${'custom'}
        .groupType=${GroupType.STUDENTS}
        custom-title="Lektionen auswählen"
        dark-cards
        @lessonClicked=${async (e: CustomEvent) => {
          if (!e.detail.lesson) return;
          const lessonClicked = e.detail.lesson as CampusLesson;
          this._link = `${projectConfig.get('CAMPUS_URL')}chancencampus/student/play/${lessonClicked._id}`;
          await this.close({ link: this._link, lessonName: lessonClicked.name });
        }}
      ></campus-component-section-lesson-list>
    `;
  }
}

export const campusTinyPluginJumpMarks: XTinyMCEPlugin = {
  name: 'campus-tiny-plugin-jumpmarks',
  setup: (editor, url) => {
    const openDialog = async () => {
      const linkObject = await CampusTinyPluginJumpmarks.showPopup<{ link: string; lessonName: string } | undefined>();
      editor.insertContent(
        `<a href="${linkObject?.link}" style="color: #efa018" target="_blank">${linkObject?.lessonName}</a>`,
        {
          format: 'raw',
        },
      );
    };
    /* Add a button that opens a window */
    editor.ui.registry.addButton('campus-tiny-plugin-jumpmarks', {
      icon: 'browse',
      onAction: async () => {
        /* Open window */
        await openDialog();
      },
    });
    /* Return the metadata for the help plugin */
    return {
      getMetadata: () => {
        return {
          name: 'Example plugin',
          url: 'http://exampleplugindocsurl.com',
        };
      },
    };
  },
};
